import { render } from "./thisOrThatFour.vue?vue&type=template&id=0c035e27"
import script from "./thisOrThatFour.vue?vue&type=script&lang=js"
export * from "./thisOrThatFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__